<template>
  <div>
    <v-container>
      <h2 class="text-h4 mb-4">Profiles</h2>
      <v-card class="mb-4" style="padding: 10px">
        <v-col cols="12" md="3">
          <v-text-field
            v-model="search_keyword"
            label="Search Profile"
            outlined
            dense
            placeholder="Search Profile"
            hide-details
          ></v-text-field>
        </v-col>
      </v-card>
      <v-data-table :search="search_keyword" :headers="headers" :items="feeds" :items-per-page="5" class="elevation-1">
        <template v-slot:body="{ items }">
          <tbody v-if="!loading_data">
            <tr v-for="item in items" :key="item.id">
              <td>{{ item.title }}</td>
              <td>
                <div v-if="item.has_collection && item.collection_names && item.collection_names.length > 0">
                  <v-chip
                    v-for="(name, index) in item.collection_names.slice(0, 2)"
                    :key="index"
                    small
                    color="info"
                    text-color="white"
                    class="mr-1"
                  >
                    {{ name }}
                  </v-chip>
                  <v-chip
                    v-if="item.collections_count > 2"
                    x-small
                    color="grey"
                    text-color="white"
                    class="ma-1"
                  >
                    +{{ item.collections_count - 2 }} more
                  </v-chip>
                </div>
                <span v-else class="text-body-2 grey--text">N/A</span>
              </td>
              <td>{{ item.product_count }}</td>
              <td>
                {{ item.created | date_format('timeago') }}
              </td>
              <td>
                <router-link :to="{ name: 'feed-details', params: { feed_id: item.id } }">
                  <v-btn fab small color="primary darken-1" class="table-action--button">
                    <v-icon small dark>{{ icons.mdiLogin }}</v-icon>
                  </v-btn>
                </router-link>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="7" class="text-center" style="padding: 80px 0px">
                <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'
import { mdiLogin } from '@mdi/js'
export default {
  name: 'Feeds',
  data() {
    return {
      search_keyword: null,
      loading_data: false,
      feeds: [],
      headers: [
        {
          text: 'Profile Name',
          value: 'title',
        },
        { text: 'Collections', value: 'collections' },
        { text: 'Total Products', value: 'product_count' },
        { text: 'Created', value: 'created' },
        { text: 'Actions', value: 'actions' },
      ],
      icons: {
        mdiLogin,
      },
    }
  },
  mounted() {
    this.shopdetail = store.getters.loggedInShop
    this.fetchShopFeeds()
  },
  methods: {
    async fetchShopFeeds() {
      try {
        try {
          this.loading_data = true
          let response = await axios.get(`admin/shops/${this.shopdetail.id}/get-feeds`)
          if (response.data.success) {
            this.feeds = response.data.feeds
          }
        } catch (e) {
        } finally {
          this.loading_data = false
        }
      } catch {
      } finally {
      }
    },
  },
}
</script>
